<template>
  <div>

      <el-row>
          <div v-if="isTelco()" style="padding-top: 1.25em; padding-bottom: 0.75em;">
            <el-switch
              style="display: block"
              size="small"
              v-model="showAllSites"
              active-color="#13ce66"
              inactive-color="#ff4949"
              :active-text="'All ' + towerName + ' Sites'"
              :inactive-text="'Only ' + orgName + ' Sites'"
              :disabled="disabled"
              @change="resetSearch">
          </el-switch>
        </div>

        <div v-else style="padding-top: 1.75em;"></div>
      </el-row>

    <el-form label-position="left">

      <el-row :gutter="9">

        <el-col v-if="!editLatLng" :sm="24" :md="12" :lg="8" align="left">
          lat: <b>{{formatNumber(this.search.lat, 12)}}</b> | lng:<b> {{formatNumber(this.search.lng, 12)}}</b>
          &nbsp;<el-button size="mini" type="primary" plain icon="fa fa-edit" @click="editLatLng = true" :disabled="disabled" />
        </el-col>

        <el-col v-else :sm="24" :md="12" :lg="8" align="center">
          <float-input
            prefix="Lat."
            suffix="&deg;"
            v-model="search.lat"
            :size="size"
            :decimals="17"
            placeholder="Latitude"
            :disabled="disabled" />

          <float-input
            prefix="Lng."
            suffix="&deg;"
            v-model="search.lng"
            :size="size"
            :decimals="17"
            placeholder="Longitude"
            :disabled="disabled" />
        </el-col>

        <el-col :sm="24" :md="12" :lg="8" align="right">
          <el-tooltip content="Radius" :placement="pl">
          <el-slider
            v-model="search.radius"
            prefix="Radius"
            suffix="km."
            :min="1"
            :max="20"
            show-input
            :size="size"
            placeholder="Radius"
            :disabled="disabled" />
          </el-tooltip>

        </el-col>

      </el-row>


      <el-row :gutter="9">

        <el-col  :sm="24" :md="12" :lg="8" align="left">

          <el-tooltip content="Zoom Level" :placement="pl">
            <!-- A plain el-select, like Map Style: SelectInput gives el-option the whole
                 object as its value but keeps the primitive in v-model, so it could
                 never match and showed the raw number (11) instead of the level name. -->
            <el-select v-model="search.zoom" :size="size" :disabled="disabled">
              <el-option v-for="z in zoomLevel" :key="z.value" :label="z.label" :value="z.value" />
            </el-select>

          </el-tooltip>
        </el-col>

        <el-col  :sm="24" :md="12" :lg="8" align="center">
          <el-tooltip content="Map Style" :placement="pl">

            <el-select v-model="styleType" :size="size" :disabled="disabled">
              <el-option label="Discreet" value="discreet" />
              <el-option label="Elevation" value="elevation" />
              <el-option label="Light Grey" value="grey" />
              <el-option label="Jade" value="jade" />
              <el-option label="Jamie" value="jamie" />
              <el-option label="Muted Blue" value="mutedblue" />
              <el-option label="Outspoken" value="outspoken" />
              <el-option label="Flat Pale" value="flatpale" />
            </el-select>

          </el-tooltip>
        </el-col>

        <el-col  :sm="24" :md="12" :lg="8">
          <el-form-item class="pull-right">
            <el-button-group>
              <el-button type="primary" :size="size" icon="fa fa-search" @click="geoSearch" :disabled="disabled">Search</el-button>
              <el-button type="info" :size="size" icon="fa fa-times-circle" @click="resetSearch" :disabled="disabled"></el-button>
            </el-button-group>
          </el-form-item>
        </el-col>

      </el-row>

    </el-form>



    <el-row type="flex" justify="center" :class="{ 'map-bar--legend': hasLegendEntries && showLegend && !showProgress }">

      <el-col align="left" class="map-bar__side">
        <el-tooltip content="Show/Hide Moveable Search Marker">

          <el-switch v-model="showMarker"
          :size="size"
          active-icon-class="fa fa-map-marker"
          inactive-icon-class="fa fa-map-marker-alt"
          :disabled="disabled" />
        </el-tooltip>

        &nbsp;

        <el-tooltip content="Show/Hide Radius Circle">
          <el-checkbox v-model="showCircle" :size="size" :disabled="disabled">
            <i :class="showCircle ? 'fa fa-plus-circle'
            : 'fa fa-minus-circle'"></i>
          </el-checkbox>
        </el-tooltip>

        &nbsp;

        <el-tooltip content="Show/Hide Nearby Points of Intrest">
          <el-checkbox v-model="showPoi" :size="size" disabled>
            <i :class="showPoi ? 'fa fa-map-signs'
            : 'fa fa-trash-alt-location'"></i>
          </el-checkbox>
        </el-tooltip>

      </el-col>

      <el-col :span="18" align="center" class="map-bar__centre">
        <div v-if="showProgress">
          <el-progress :text-inside="true" :stroke-width="18" :percentage="progress"></el-progress>
        </div>

        <div v-else>
          <div v-if="showLegend">
            <el-col v-if="leg.title && !hasLegendEntries" :span="6">
              <span class="text-muted">{{leg.title}}</span>
            </el-col>

            <div v-if="hasLegendEntries" class="map-legend">
              <span v-if="leg.title" class="map-legend__title">{{leg.title}}</span>
              <ul class="map-legend__list" role="list" :aria-label="(leg.title ? leg.title : 'Map') + ' legend'">
                <li v-for="(l, i) in leg.legend" :key="'legend-' + i" class="map-legend__item">
                  <span v-if="l.colour" class="map-legend__swatch" :style="{ backgroundColor: l.colour }" role="img" :aria-label="l.alt ? l.alt : ''"></span><img v-else class="map-legend__icon" :src="l.icon" :alt="l.alt ? l.alt : ''" width="9" height="9">{{l.label}}
                </li>
              </ul>
            </div>
          </div>
        </div>

      </el-col>


      <el-col align="right" class="map-bar__side">
        <el-tooltip content="Reset &amp; Center Map">
          <el-button type="success" :size="size" icon="fa fa-arrows-alt" @click="resetMap()" :disabled="disabled" />
        </el-tooltip>
      </el-col>

  </el-row>


  <el-row>
    <el-col :span="24">

      <gmap-map
          ref="xolasMap"
          :center="search"
          :options="{styles: style}"
          :zoom="search.zoom"
          map-type-id="terrain"
          style="width: 100%; height: 52.8vh;">

        <gmap-marker
            v-if="showMarker"
            :position="search"
            :clickable="true"
            :draggable="true"
            :icon="dragIcon()"
            @dragend="updatePos">
        </gmap-marker>

        <gmap-circle v-if="showMarker && showCircle"
          :center="{lat: Number(this.search.lat), lng: Number(this.search.lng)}"
          :radius="Number(this.search.radius / 6.5) * this.search.km"
          :options="mapCenterOptions">
        </gmap-circle>

        <gmap-marker
          v-for="m in markers" :key="m.content.id"
          :position="m.position"
          :clickable="true"
          :icon="mapIcon(leg.prop, m)"
          @click="center=m.position"
          @mouseover="legendStatus(m)"
          @mouseout="statusText = null"
          @mousedown="m.visible=true">

          <gmap-info-window
            :opened="m.visible"
            @closeclick="m.visible=false">

            <!-- Site popup (XOL-563). One compact label/value line each; a line with no
                 value is hidden, except Sharers, which says "Unknown". Telco and Handover
                 are Tower Co only: gated here as well as by the API. -->
            <div class="map-popup">
              <strong class="map-popup__title">{{m.content.siteName}}</strong>

              <div v-if="hasPopupValue(m.content.siteId)" class="map-popup__row">
                <span class="map-popup__label">Site ID</span><span class="map-popup__value">{{m.content.siteId}}</span>
              </div>

              <div v-if="isTowerCo() && hasPopupValue(m.content.telcos)" class="map-popup__row">
                <span class="map-popup__label">Telco</span><span class="map-popup__value">{{m.content.telcos}}</span>
              </div>

              <div v-if="hasPopupValue(m.content.structureType)" class="map-popup__row">
                <span class="map-popup__label">Structure</span><span class="map-popup__value">{{m.content.structureType}}<span v-if="Number(m.content.structureHeight) > 0"> ({{m.content.structureHeight}}m)</span></span>
              </div>

              <div v-if="hasPopupValue(m.content.status)" class="map-popup__row">
                <span class="map-popup__label">Status</span><span class="map-popup__value">{{m.content.status}}</span>
              </div>

              <div v-if="hasPopupValue(popupCoordinates(m))" class="map-popup__row">
                <span class="map-popup__label">Coordinates</span><span class="map-popup__value">{{popupCoordinates(m)}}</span>
              </div>

              <div class="map-popup__row">
                <span class="map-popup__label">Sharers</span><span class="map-popup__value">{{popupSharers(m)}}</span>
              </div>

              <div v-if="isTowerCo() && hasPopupValue(m.content.handover)" class="map-popup__row">
                <span class="map-popup__label">Handover</span><span class="map-popup__value">{{m.content.handover}}</span>
              </div>
            <!--      <el-button v-if="isTowerCo()" @click="viewSite(m.content.siteId)" type="primary">View</el-button> -->
            <!--            <request-share-action :siteId="m.content.id" />
            <ticket-action buttonSize="small" :row-data="{}" />  -->
            </div>
        </gmap-info-window>

        </gmap-marker>

        <template #visible><div>
          <div style="bottom: 0; left: 0; background-color: slategrey; text-align: center; color: ivory; width: 100%; position: absolute; z-index: 100">
            {{statusText}}
          </div>
        </div></template>
      </gmap-map>

      </el-col>
    </el-row>

    <el-collapse v-model="menu" accordion>

      <el-collapse-item name="nearby" v-if="showPoi">
          <template #title>
            <i class="header-icon fa fa-map">&nbsp;</i>Nearby Places
          </template>

          <nearby-places :lat="search.lat" :lng="search.lng" :radius="search.radius" />

      </el-collapse-item>

      <el-collapse-item v-if="showSites" name="sites">
          <template #title>
            <i class="header-icon fa fa-broadcast-tower">&nbsp;</i>Sites
          </template>
            <sites-table
              v-if="this.totalMapMarkers > 0"
              :title="'Map Search Sites (' + formatInteger(isTelco() ? this.sharerMarkers : this.totalMarkers) + ')'"
              :geo-search="search"
              :sharer="sharerId"
              condensed
              :show-map="false" />
        </el-collapse-item>

  </el-collapse>

  </div>

</template>


<script>

import Vue from 'vue'

import {GOOGLE_API_KEY, MAP_SEARCH_EVENT, MAP_RESET_EVENT} from '@/components/Data'

import {disrcreetMapStyle, elevationMapStyle, jadeMapStyle, jamieMapStyle,
    lightGreyMapStyle, outspokenMapStyle, mutedBlueMapStyle, flatPaleMapStyle} from '@/components/maps/styles/GoogleMapStyles'


import ArrayMixins from '@/mixins/ArrayMixins'
import GoogleMapMixins from '@/mixins/GoogleMapMixins'

import * as GMap from 'gmap-vue'

import NearbyPlaces from '@/components/maps/NearbyPlaces'
import SitesTable from '@/components/tables/SitesTable'

Vue.use(GMap, {
  load: {
    key: GOOGLE_API_KEY,
    libraries: 'places'
  }
})



export default {
  mixins: [ArrayMixins, GoogleMapMixins],


  components: {
    SitesTable,
    NearbyPlaces
  },


  props: {
    sharer: {
      type: Number,
      default: null
    },

    showLegend: {
      type: Boolean,
      default: true
    },

    showSites: {
      type: Boolean,
      default: true
    },

    legend: {
      type: Object,
      required: true
    },

    zoom: {
      type: Number,
      default: 11
    },

    mapStyle: {
      type: String,
      validator: function (value) {
        return value !== null ? ['discreet', 'elevation', 'grey', 'jade', 'jamie', 'outspoken', 'mutedblue', 'flatpale'].indexOf(value) !== -1 : true
      },
      default: 'grey'
    }
  },



  methods: {

    updateProgress (progress) {
      this.progress = progress.percent
      this.totalMapMarkers = progress.total
    },


    loadingFinished () {
      this.showProgress = false
      this.disabled = false
      this.resetMap()

      if (this.showPoi) {
        this.loadPoi(this.search.lat, this.search.lng, this.search.radius)
      }
    },


    updatePos (e) {
      this.search.lng = e.latLng.lng()
      this.search.lat = e.latLng.lat()
    },


    resetMap () {

//      console.log('map ref', this.$refs.xolasMap.$mapObject)

      if (this.bounds && this.bounds.isEmpty()) {
        this.resetBounds()

//        this.search.lat = Number(this.center.lat)
//        this.search.lng = Number(this.center.lng)

        let position = {lat: this.search.lat, lng: this.search.lng}
        this.bounds.extend(position)

      }

      this.$refs.xolasMap.panToBounds(this.bounds)
      this.$refs.xolasMap.fitBounds(this.bounds)
    },


    // undefined, null, '' (or only spaces) and an empty array are "no value"
    hasPopupValue (value) {
      if (value === null || value === undefined) {
        return false
      }

      if (Array.isArray(value)) {
        return value.length > 0
      }

      return String(value).trim() !== ''
    },


    // "lat, lng" to 6 decimals from the marker position; '' when either is not a number
    popupCoordinates (m) {
      var lat = m && m.position ? Number(m.position.lat) : NaN
      var lng = m && m.position ? Number(m.position.lng) : NaN

      if (!isFinite(lat) || !isFinite(lng)) {
        return ''
      }

      return lat.toFixed(6) + ', ' + lng.toFixed(6)
    },


    // the same count the marker colour uses (GoogleMapMixins.hasSharerCount)
    popupSharers (m) {
      return this.hasSharerCount(m.content.sharers) ? Number(m.content.sharers) : 'Unknown'
    },


    viewSite (siteId) {
      this.$root.$data.routes.push({name: 'site', params: { id: siteId }})
    },



    geoSearch () {
      this.editLatLng = false
      this.disabled = true

      this.resetBounds()
//      console.log('search', this.search.lat, this.search.lng)

      var url = this.getEndpoint(this.geoSearchUrl)

      this.$events.emit(MAP_SEARCH_EVENT, this.search)
      this.loadMapMarkers(url, this.bounds)

    },

    resetSearch () {

      this.editLatLng = false

      this.resetBounds()

//      this.search.lat = Number(this.center.lat)
//      this.search.lng = Number(this.center.lng)

      this.$events.emit(MAP_RESET_EVENT)

      this.loadMapMarkers(this.getEndpoint(this.defaultUrl), this.bounds)
    },

    mapIcon (prop, m) {
      if (m && m.content) {
        return this.leg.mapIcon(m.content[prop])
      } else {
        return this.defaultIcon()
      }
    },


    legendStatus (m) {
      this.statusText = 'No status found.'

      if (this.leg && this.leg.statusFormatter && this.isFunction(this.leg.statusFormatter)) {
        this.statusText = this.leg.statusFormatter(m)
      }

      return this.statusText
    },

    getMapStyle (style = null) {

      let s = style ? style : this.styleType
      s = this.findInList('name', s, this.mapStyles)
      return s ? s.style : null
    },


    sharerChange (val) {
      this.sharerId = val === 0 ? null : Number(val)
      this.loadMapMarkers(this.getEndpoint(this.defaultUrl), this.bounds)
    }

  },



  watch: {

    sharer: function (value) {
      this.sharerId = value
    },

    styleType: function (value) {
      this.style = this.getMapStyle(this.styleType)
    }

  },


  computed: {

    hasLegendEntries () {
      return !!(this.leg && this.leg.legend && this.leg.legend.length)
    },

    // API plan XOL-547 section 12(a): the server decides what each scope returns.
    scopePath () {
      if (this.isTowerCo()) {
        // Tower Co: bare = all sites; HomeMap's sharer picker sends /org/{X}.
        return this.sharerId ? '/org/' + this.sharerId : ''
      }

      // Non-Tower-Co: never send another org's id (403). sharerId is ignored.
      // Only a Telco has the All/Only switch; every other category is always
      // its own set, whatever showAllSites says.
      if (this.isTelco() && this.showAllSites) {
        return '/all'
      }

      var o = this.org()
      return (o && o.id) ? '/org/' + o.id : ''
    },

    defaultUrl () {
      return '/view/map' + this.scopePath
    },

    // Radius = default URL + /{lat}/{lng}/{r}/km (always km, never a page segment).
    geoSearchUrl () {
      return this.defaultUrl + '/' + this.search.lat + '/' + this.search.lng + '/' + this.search.radius + '/km'
    },

    towerName () {
      const c = this.xolasClient()
      return c.shortName ? c.shortName : c.name
    },

    orgName () {
      const o = this.org()
      const name = o.shortName ? o.shortName : o.name
      if (typeof name === 'undefined' || name === this.towerName) {
        return 'Your'
      }
      return name
    }

  },



  data () {

    return {
      menu: 'sites',
      pl: 'left',
      sharerId: this.sharer,
      leg: this.legend,

      activePane: 'map',
      size: 'mini',
      totalMapMarkers: 0,

      statusText: null,

      showAllSites: false,
      selectView: null,
      showMarker: false,
      showCircle: true,
      showPoi: false,
      disabled: true,

      zoomLevel: [
        {label: 'World', value: 1},
        {label: 'Continent', value: 5},
        {label: 'Country', value: 7},
        {label: 'Region', value: 9},
        {label: 'State', value: 11},
        {label: 'City', value: 13},
        {label: 'Streets', value: 15},
        {label: 'Buildings', value: 20}
      ],

      mapStyles: [
        {name: 'discreet', style: disrcreetMapStyle},
        {name: 'elevation', style: elevationMapStyle},
        {name: 'jade', style: jadeMapStyle},
        {name: 'jamie', style: jamieMapStyle},
        {name: 'grey', style: lightGreyMapStyle},
        {name: 'outspoken', style: outspokenMapStyle},
        {name: 'mutedblue', style: mutedBlueMapStyle},
        {name: 'flatpale', style: flatPaleMapStyle}
      ],

      center: this.getStore().baseMap,
      styleType: this.mapStyle,
      style: null,

      searchEnabled: false,
      showProgress: true,
      editLatLng: false,
      legendType: 'Sharers',
      progress: 0,

      search: {
        lat: this.getStore().baseMap.lat,
        lng: this.getStore().baseMap.lng,
        radius: 5,
        zoom: this.zoom,
        mi: 3963.1676,
        km: 6378.1,
        ft: 20925524.9,
        mt: 6378100,
        fa: 3487587.49,
        na: 3443.89849,
        ch: 317053.408,
        rd: 1268213.63,
        fr: 31705.3408
      },

      mapCenterOptions: {
        strokeColor: 'indianred',
        strokeOpacity: 0.432,
        strokeWeight: 2,
        fillColor: 'indianred'
      }

    }
  },


  created () {
    this.style = this.getMapStyle(this.mapStyle)
  },

  mounted () {


    this.$events.on('progress', this.updateProgress)
    this.$events.on('finished', this.loadingFinished)

    this.loadMapMarkers(this.getEndpoint(this.defaultUrl), this.bounds)
  },

  beforeDestroy () {
    this.$events.off('progress', this.updateProgress)
    this.$events.off('finished', this.loadingFinished)
  }

}
</script>

<style scoped>
/* Only while the legend is actually shown (SharerMap, after loading): the side cols have no span, so
   el-col makes them 100% wide and flex-shrink squeezes the centre col to about
   a quarter of the row. Size the side cols to their content and give the centre
   col the rest, so the key sits on one line between the controls when it fits
   and wraps inside the centre col when it does not. No span is changed, and a
   bar without a legend (TenancyExpiryMap) does not get this class, and neither
   does the bar while the progress bar shows, so that keeps its original length. */
.map-bar--legend {
  align-items: center;
}
.map-bar--legend > .map-bar__side {
  flex: 0 0 auto;
  width: auto;
  max-width: none;
}
.map-bar--legend > .map-bar__centre {
  flex: 1 1 auto;
  width: auto;
  max-width: none;
  min-width: 0;
}
.map-legend {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  min-height: 28px;
  font-size: 14px;
  line-height: 20px;
  color: #606266;
}
.map-legend__title {
  font-weight: 600;
  margin-right: 8px;
}
.map-legend__list {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  list-style: none;
  margin: 0;
  padding: 0;
}
.map-legend__item {
  display: inline-flex;
  align-items: center;
  margin: 0 10px;
  white-space: nowrap;
}
/* A CSS circle rather than the 9px marker PNG (upscaling it would blur): same
   fill as the marker, ringed like it. */
.map-legend__swatch {
  display: inline-block;
  box-sizing: border-box;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 2px solid rgba(0, 0, 0, 0.75);
  margin-right: 6px;
  vertical-align: middle;
}
/* fallback when an entry has no colour: the marker PNG, at its native size */
.map-legend__icon {
  width: 9px;
  height: 9px;
  margin-right: 6px;
}
/* Site popup (XOL-563): small muted label, value beside it, one line each. */
.map-popup {
  min-width: 200px;
  max-width: 280px;
  text-align: left;
  font-size: 13px;
  line-height: 1.5;
}
.map-popup__title {
  display: block;
  margin-bottom: 4px;
  font-size: 15px;
}
.map-popup__row {
  display: flex;
  align-items: baseline;
}
.map-popup__label {
  flex: 0 0 84px;
  font-size: 12px;
  color: #606266;
}
.map-popup__value {
  flex: 1 1 auto;
  min-width: 0;
  overflow-wrap: anywhere;
}
</style>
